module.exports = __webpack_public_path__ + "media/cuttlefish/arrowUp-green-53e9395d.svg";